/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Snackbar, Divider, Box,  TextField, Button, IconButton,  } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import uiConf from "../../config/uiConf";
import apiClient from "../../lib/common/apiClient";
import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import { Alert } from "@material-ui/lab";
import { makeStyles } from '@material-ui/core/styles';
import AutoForm from "../form/functional/AutoForm";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";
import FormItemRadio from "../form/input/FormItemRadio";
import FormItemText from "../form/input/FormItemText";
import { getNum } from "../../lib/TkPopUtils/TkPopProductMangeDetailUtils";
import defineConf from "../../config/defineConf";

const InputLabelProps = {
    shrink : true,
    style : {
        fontSize : "large",
        fontWeight: "bold",
    }
}

const useStyles = makeStyles({

    input: {
      '& input[type=number]': {
          '-moz-appearance': 'textfield'
      },
      '& input[type=number]::-webkit-outer-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0
      },
      '& input[type=number]::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0
      }
    },
  });

function TkWireCustomForm (props) {

    const {onClick, data, names, onChange, t} = props;
    const classes = useStyles();

    return (

            <Box 
                style = {{margin : '10px', padding : "5px",  display : 'flex', justifyContent : 'center' }}
                border = {1}
                borderColor="grey.500"
                borderRadius={20}
            >    
                <Box style = {{padding : `15px`, display : 'flex', width : "100%", justifyContent : 'center'}}>

                    <TextField
                        className={classes.input} 
                        style = {{
                            width : '35%',
                            height : `50px`,
                            marginInline : `10px`
                        }}
                        name = {names.firstFormItem}
                        value = {data.circleOrSquare}
                        type = "number"
                        label = {data.radioCircleOrSquare === "circle" ? t("term.pi") + " / (" + t("term.circle") + ")" : t("term.length") +" / (" + t("term.square") +")"}
                        onChange={(e)=> onChange(e, data.id)}
                        InputLabelProps ={InputLabelProps}
                        />
                    <TextField
                        className={classes.input} 
                        style = {{
                            width : '35%',
                            height : `50px`,
                            marginInline : `10px`
                        }}
                        name =  {names.secoundFormItem}
                        value = {data.angleOrStraightOrNormalOrAngle}
                        type = "number"
                        label = {
                            data.radioAngleOrStraightOrNormalOrAngle === "angle" 
                            ? 
                                t("term.count") + " / (" +  t("term.angle") + ")" 
                            : 
                                data.radioAngleOrStraightOrNormalOrAngle === "normal" 
                                ?
                                    t("term.count") + " / (" + t("term.normal") + ")" 
                                : 
                                    t("term.count") + " / (" + t("term.angleStraight") + ")" }
                        onChange={(e)=> onChange(e, data.id)}
                        InputLabelProps ={InputLabelProps}
                    />

                    <IconButton aria-label="delete" onClick={()=> onClick(data.id)}>
                        <DeleteIcon fontSize="large" />
                    </IconButton>
                </Box>
            </Box>
    )
}

function TkWireRadio (props) {

    const { onChange, id, value, label, selectItems } = props;

    return (
        <FormItemRadio
            id={id}
            label={label}
            value={value}
            column={selectItems}
            onChange={onChange}
            InputLabelProps ={InputLabelProps}
        />
    );
}

function TkCamWireDialog ( props ) {

    const { t } = useTranslation ();
    const [instance, setInstance] = useState ();
    const [formData, setFormData] = useState({});
    const [interaction, setInteraction] = useState(false);

    const [isAutoFormChange, setIsAutoFormChange] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const classes = useStyles();

    const [circleOrSquare, setCircleOrSquare] = useState("circle");

    const [angleOrStraightOrNormalOrAngle, setAngleOrStraightOrNormalOrAngle] = useState("angle");
    
    const [customFormData, setCustomFormData] = useState([]);

    const [radioFirstTextFeild, setRadioFirstTextFeild] = useState();
    const [radioSecoundTextFeild, setRadioSecoundTextFeild] = useState();
    
    // 차수
    const [wCamNum, setwCamNum] = useState();

    const customFormNames = {
        firstFormItem : "circleOrSquare",
        secoundFormItem : "angleOrStraightOrNormalOrAngle"
    }

    const {
        id,
        moveable,
        resizable,
        fullWidth,
        maxWidth,
        schema,
        formId,
        title,
        onClose,
        onInitialized,
        onSuccess,
        initialData,
        onSelectMst,
        onSelectDetail,
        mode,
        ...others
        
    } = props;

    useEffect(()=> {

        (async()=> {

            if(mode === "edit") {

                setFormData({...initialData});

            } else if( mode === "create" && others.open){
                
                setwCamNum(await getNum(onSelectMst.parentPlanId, "CAM(WCM)"));
                
                setFormData((prevFormData) => {
                    let newFormData = {
                        ...prevFormData,
                        num: wCamNum,
                        size : defineConf.sizeType.SMALL
        
                    }
                    return newFormData
                })
            }

        })();

    },[others.open, wCamNum, mode, onSelectMst]);

    const notifyFailure = (msg) => {
        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onNotifySuccess = ( msg ) => {

        notifySuccess ( msg );

    };

    const onApiSuccess = (result) => {

        if  ( onSuccess ) {

            setTimeout ( ( ) =>  onSuccess ( result.data ), 0 );

        } else {

            onNotifySuccess ( result.data );

        }
        
        instance.hide();

    };

    const nofifyWarning = (msg) => {

        console.warn (msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const onApiFailure = (reason) => {
        notifyFailure ( reason.response ? reason.response.data : reason );

    };

    const checkItemValidataion = (schema, formData) => {

        for (const column of schema.columns) {
            let [valid, msg] = checkValidation("create", column, column.validation, formData[column.name] || "");


            if (!valid) {

                nofifyWarning(msg);
                return false;

            }

        }

        return true;

    }

    const onOk = ( schema, formData, customFormData ) => {

        if ( ! checkItemValidataion ( schema, formData ) ) {

            console.error ( "Form Validation Failed" );

            return;

        }

        if (schema.validation) {

            let [valid, msg] = checkConditionWithMsg(

                formData,
                schema.validation

            );

            if (!valid) {

                nofifyWarning ( t ( "warning.formDataValidationFail", { msg: msg } ) );
                return;

            }

        }

        if(customFormData.length < 1) {
            nofifyWarning ( t ( "warning.customFormLengthMoreOne" ) );
            return;
        }

        for(let data of customFormData) {

            if(!( data.angleOrStraightOrNormalOrAngle && data.circleOrSquare )) {
                nofifyWarning ( t ( "warning.checkInputOfThePiAndLengthNumber" ) );
                return;
            }

        }

        let url ;
        let form = new FormData();
        let json = {};
        let deleted = {};
        let apiData = {};

        let customFormatFormData = [...customFormData];

        switch(mode) {

            case "edit" :

                apiData = {...formData, customFormatFormData};
                json = {...apiData};
                url = `/api/TkPopProductManageDetail/wcmCam/${onSelectDetail.planDetailId}`

                form.append("deleted", JSON.stringify(deleted));
                form.append("json", JSON.stringify(json));
                apiClient
                    .patch(url, form, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((result) => onApiSuccess(result, schema))
                    .catch((reason) => onApiFailure(reason));

            break;

            default :

            url = `/api/TkPopProductManageDetail/wcmCam`

                apiData = { ...formData, customFormatFormData, planId : onSelectMst.planId, processCode : onSelectMst.processCode };
                json = {...apiData};
                deleted = {};
                form.append ( "deleted", JSON.stringify ( deleted ) );
                form.append ( "json", JSON.stringify ( json ) );
                apiClient
                    .post(url, form, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((result) => onApiSuccess(result))
                    .catch((reason) => onApiFailure(reason));

                break;
        }
    }

    const onCancel = () => {

        instance.hide();

        setFormData(
            { 
                num: wCamNum,
            }
        );

    };

    const onCustomFormChange = ( e, id ) => {

        let {name, value} = e.target;

        if(!isAutoFormChange && mode === "edit") {

            setFormData(
                {
                    /* workTime : onSelectDetail.workTime, */
                    workers : onSelectDetail.workers,
                    num : onSelectDetail.num,
                    wCutNum : onSelectDetail.wCutNum,
                    size : onSelectDetail.size
                }
            )
        }

        setCustomFormData((items) =>items.map((item)=> item.id === id ? {...item, [name] : value} : item));

        setInteraction(true);

    }

    const onAutoFormChange = ( autoFormData ) => {

        setFormData((prevFormData)=> {

            let newFormData = {
                ...prevFormData,
                workTime : autoFormData.workTime,
                workers : autoFormData.workers,
                num : autoFormData.num,
                wCutNum : autoFormData.wCutNum,
                size : autoFormData.size,
            }

            return newFormData

        })

        setIsAutoFormChange(true);
        setInteraction(true);

    }

    const onCloseNotification = () => {

        setNotification( ( notification ) => {

            return ({...notification, open: false});

        } );

    };

    const onCloseDialog = () => {

        if ( onClose ) {

            onClose ();

        }
        
        setFormData(()=> {

            let newFormData = {
                num : wCamNum,
            }

            return newFormData
        
        });

        
        setCustomFormData([]);
        setRadioFirstTextFeild();
        setRadioSecoundTextFeild();
        setInteraction(false);
        
    }

    const onDialogInitialized = (instance) => {

        setInstance(instance);

        if (onInitialized) {

            onInitialized(instance);

        }

    };

    const onCustomFormCreateClick = (e)=> {

        if(customFormData.length >= 30) {

            nofifyWarning ( t ( "warning.checkInputOfThePiAndLengthNumber" ) );

        } else {

            setCustomFormData((prevCustomFormData)=> {

                let newTest = [
                    ...prevCustomFormData,
                    {
                        id : customFormData.length,

                        circleOrSquare : radioFirstTextFeild,
                        radioCircleOrSquare : circleOrSquare,

                        radioAngleOrStraightOrNormalOrAngle : angleOrStraightOrNormalOrAngle,
                        angleOrStraightOrNormalOrAngle : radioSecoundTextFeild,  
                    }
    
                ];
    
                return newTest;
    
            })

            setInteraction(true)
        }
    }

    const onDeleteClick = (id)=> {

        setCustomFormData((prevCustomFormData)=> {

            let newCustomFormData = prevCustomFormData.filter((customForm)=> (customForm.id !== id));
            
            return newCustomFormData

        })
    }

    const onRadioFirstTextFeildChange = (value)=> {

        setRadioFirstTextFeild(value);
    }
    
    const onRadioSecoundTextFeildChange = (value)=> {

        setRadioSecoundTextFeild(value);

    }

    return (

        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="md"
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >
            <DialogHeaderWithClose>
                <DialogTitle>
                    { t ( title ) }
                </DialogTitle>
            </DialogHeaderWithClose>

            <DialogContent style={{padding: "0px", height: "600px" }}>

            <Box
                style = {{
                    padding : '16px',
                    display : 'flex',
                    justifyContent : 'center',
                    flexDirection : 'column'
                }}>

                <AutoForm
                    id="wire-data-create-form"
                    schema={schema}
                    mode="edit"
                    initialData={formData}
                    onChange={onAutoFormChange}

                />

            </Box>
            
            <hr></hr>
            <div 
                style ={{
                    display : "flex",
                    flexDirection : 'column',
                }}>
                <div 
                    style = {{
                        display : "flex",
                        justifyContent : "space-evenly"
                    }}>
                    <TkWireRadio
                        t = {t}
                        onChange = {(value)=> {
                            setCircleOrSquare(value);
                        }}
                        value = {circleOrSquare}
                        label = {t("radio.label.circleOrsquare")}
                        selectItems ={
                            {
                                name: "",
                                row: true,
                                formControlStyle: { margin: 0, paddingTop: 9},
                                selectItems: [
                                    {
                                        name: t("selectItems.tkWire.circle"),
                                        value: "circle"
                                    },
                                    {
                                        name: t("selectItems.tkWire.square"),
                                        value: "square"
                                    },
                                ]
                            }
                        }
                    />
                    <TkWireRadio
                        t = {t}
                        onChange = {(value)=> {

                            setAngleOrStraightOrNormalOrAngle(value);
                        }
                        }
                        value = {angleOrStraightOrNormalOrAngle}
                        label = {t("radio.label.angleOrStraightOrNormalOrAngle")}
                        selectItems ={
                            {
                                name: "angleOrNormal",
                                row: true,
                                formControlStyle: { margin: 0, paddingTop: 9},
            
                                selectItems: [
                                    {
                                        name: t("selectItems.tkWire.angle"),
                                        value: "angle"
                                    },
                                    {
                                        name: t("selectItems.tkWire.normal"),
                                        value: "normal"
                                    },
                                    {
                                        name: t("selectItems.tkWire.angleStraight"),
                                        value: "angleStraight"
                                    },
                                ]
                            }
                        }
                        />
                    <FormItemText
                        className={classes.input} 
                        column = {{
                            name: "circleOrSquare",
                            type: "float",
                            formOrder: 3,
                            formItemType: "float",
                            style : {paddingTop : `20px`},
                            InputProps : {
                                type : "number"
                            }
                        }}
                        InputLabelProps = {{
                            shrink : true,
                            style : {
                                fontSize : "large",
                                fontWeight: "bold",
                                paddingTop : "20px"
                            }}}
                        label = {circleOrSquare === "circle" ? t("term.pi") : t("term.length")}
                        onChange = {onRadioFirstTextFeildChange}
                        
                            />
                    <FormItemText
                        className={classes.input} 
                        column = {{
                            name: "angleOrStraightOrNormalOrAngle",
                            type: "float",
                            formOrder: 3,
                            formItemType: "float",
                            style : {paddingTop : `20px`},
                            InputProps : {
                                type : "number"
                            }
                        }}
                        InputLabelProps = {{
                            shrink : true,
                            style : {
                                fontSize : "large",
                                fontWeight: "bold",
                                paddingTop : "20px"
                            }}}
                            
                        label = {t("term.count")}
                        onChange = {onRadioSecoundTextFeildChange}
                    
                    />
                    <Button variant="contained" color="primary" style = {{height : "50px", marginTop : "20px"}} onClick = {onCustomFormCreateClick}>{t("common.add")}</Button>
                </div>
            </div>
            <hr></hr>
            {

                customFormData.map((data, index) =>{

                    return (

                        <TkWireCustomForm key = {index} t={t} names ={customFormNames} data = {data} onChange = {onCustomFormChange} onClick = {onDeleteClick}/>            
                    )
                })

            }
                

                <Snackbar
                    open={notification.open && notification.severity !== "success"}
                    autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                    onClose={onCloseNotification}
                >
                    <Alert
                        onClose={onCloseNotification}
                        variant="filled"
                        severity={notification.severity}
                    >

                        {notification.msg}

                    </Alert>

                </Snackbar>

            </DialogContent>

            <Divider />

            <DialogActionsOkCancel
                labels={[ mode === "create" ? t("common.add") : t("common.edit")]}
                buttonDisabled={[!interaction, false]}
                onOk={() => onOk( schema, formData, customFormData )}
                onCancel={onCancel}
            />

        </Dialog>

    );

}

export default TkCamWireDialog;
